import { Box, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackColor26,
  couponColor,
  whiteColor,
} from "../../configs/styles/muiThemes";

function MainProductCard({ products }) {
  if (products.length === 0) return null;

  return (
    <Box sx={styles.mainProductCard}>
      {products.map((item, index) => {
        return (
          <ListItem
            sx={{
              py: 0.5,
              color: { md: blackColor, xs: blackColor26 },
              listStyleType: "none", // Remove default bullet
              position: "relative",
              "&::before": {
                content: '"•"',
                position: "absolute",
                left: "0px",
                fontSize: "18px", // Small bullet size
                lineHeight: 1,
                color: "inherit",
              },
            }}
          >
            <ListItemText
              sx={{
                display: "list-item",
                margin: "2px",
              }}
              key={index + "main_product"}
              primary={
                <Typography
                  fontSize={{ xs: 11.5, md: 12.5 }}
                  color={{ md: blackColor, xs: blackColor26 }}
                  sx={{
                    lineHeight: 1.2, // Tighter line height
                  }}
                >
                  {item.productName}
                </Typography>
              }
            />
          </ListItem>
        );
      })}
    </Box>
  );
}

export default MainProductCard;

const styles = {
  mainProductCard: {
    backgroundColor: whiteColor,
    // boxShadow: {md:"0px 2px 8px rgb(94 94 94 / 16%)",xs:0},
    padding: { md: "8px 15px", xs: 0 },
    borderRadius: { md: "12px", xs: 0 },
    border: { md: `1px solid #e6ebf4` },
  },
};
